import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useEffect, useState, useCallback } from 'react';
import screenfull from 'screenfull';

var useDebounced = function useDebounced(handler, watchedValue) {
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  useEffect(function () {
    var timeoutHandler = setTimeout(function () {
      if (handler !== null) {
        handler(watchedValue);
      }
    }, delay);
    return function () {
      clearTimeout(timeoutHandler);
    };
  }, [watchedValue, delay]);
};
var useDebounced$1 = useDebounced;

function useFullscreen(element) {
  var enabled = screenfull.isEnabled;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var fullscreen = useCallback(function () {
    if (screenfull.isEnabled) {
      if (typeof element !== 'undefined' && element !== null) {
        screenfull.request(element);
      } else {
        screenfull.request();
      }
    }
  }, [element]);
  var unFullscreen = useCallback(function () {
    if (screenfull.isEnabled) {
      screenfull.exit();
    }
  }, []);
  var toggle = useCallback(function () {
    if (!active) {
      fullscreen();
    } else {
      unFullscreen();
    }
  }, [active, fullscreen, unFullscreen]);
  useEffect(function () {
    var onChange = function onChange() {
      setActive(screenfull.isFullscreen);
    };
    if (screenfull.isEnabled) {
      screenfull.on('change', onChange);
    }
    return function () {
      if (screenfull.isEnabled) {
        screenfull.off('change', onChange);
      }
    };
  }, []);
  return {
    toggle: toggle,
    fullscreen: fullscreen,
    unFullscreen: unFullscreen,
    active: active,
    enabled: enabled
  };
}

export { useDebounced$1 as useDebounce, useFullscreen };
